import { Flex, Text } from '@tradener/lumen';

import { CreditCounterpartyDetailProps } from '@graphql/query/operationLimits/credit/counterpartDetail';

export interface CounterpartySummaryCardsProps {
  detail: CreditCounterpartyDetailProps;
  isEmptyState?: boolean;
}

const valueColor = (value: number) => (value >= 0 ? 'green.500' : 'red.500');

function CounterpartySummaryCards({ detail, isEmptyState = false }: CounterpartySummaryCardsProps) {
  const exposureValue = isEmptyState ? '-' : Number(detail.exposureMtmFiltered).formatCurrency('pt-BR');
  const globalExposureValue = isEmptyState ? '-' : Number(detail.exposureMtmGlobal).formatCurrency('pt-BR');
  const limitValue = isEmptyState ? '-' : Number(detail.limitAverage).formatCurrency('pt-BR');
  const balanceValue = isEmptyState ? '-' : Number(detail.financialBalance).formatCurrency('pt-BR');
  const exposureColor = isEmptyState ? 'gray.900' : valueColor(detail.exposureMtmFiltered);
  const globalExposureColor = isEmptyState ? 'gray.900' : valueColor(detail.exposureMtmGlobal);
  const limitColor = 'gray.900';
  const balanceColor = isEmptyState ? 'gray.900' : valueColor(detail.financialBalance);

  return (
    <>
      <Flex direction="column" rowGap="0.5" borderRadius="xl" borderWidth="1px" borderColor="gray.0" bg="gray.0" py="4" px="5">
        <Text textStyle="body2-regular" color="gray.900">
          Exposição MtM
        </Text>
        <Text textStyle="h6-semibold" color={exposureColor}>
          {exposureValue}
        </Text>
        <Text textStyle="body2-regular" color="gray.500">
          Valor em risco
        </Text>
      </Flex>

      <Flex direction="column" rowGap="0.5" borderRadius="xl" borderWidth="1px" borderColor="gray.0" bg="gray.0" py="4" px="5">
        <Text textStyle="body2-regular" color="gray.900">
          Exposição MtM global
        </Text>
        <Text textStyle="h6-semibold" color={globalExposureColor}>
          {globalExposureValue}
        </Text>
        <Text textStyle="body2-regular" color="gray.500">
          Valor em risco global
        </Text>
      </Flex>

      <Flex direction="column" rowGap="0.5" borderRadius="xl" borderWidth="1px" borderColor="gray.0" bg="gray.0" py="4" px="5">
        <Text textStyle="body2-regular" color="gray.900">
          Limite
        </Text>
        <Text textStyle="h6-semibold" color={limitColor}>
          {limitValue}
        </Text>
        <Text textStyle="body2-regular" color="gray.500">
          Limite médio
        </Text>
      </Flex>

      <Flex direction="column" rowGap="0.5" borderRadius="xl" borderWidth="1px" borderColor="gray.0" bg="gray.0" py="4" px="5">
        <Text textStyle="body2-regular" color="gray.900">
          Saldo financeiro
        </Text>
        <Text textStyle="h6-semibold" color={balanceColor}>
          {balanceValue}
        </Text>
        <Text textStyle="body2-regular" color="gray.500">
          MtM + Limite financeiro
        </Text>
      </Flex>
    </>
  );
}

export default CounterpartySummaryCards;
